import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import NumberInput from 'components/NumberInput'

const NumberCellEditor = forwardRef(({t,column,node, data,  ...props}, ref) => {
    const [currentValue, setCurrentValue] = useState(parseInt(props.value));
    const refInput = useRef(null);
 
    useEffect(() => {
        // focus on the input
        refInput.current.focus();
    }, []);
 
    /* Component Editor Lifecycle methods */
    useImperativeHandle(ref, () => {
        return {
            // the final value to send to the grid, on completion of editing
            getValue() {
                return currentValue;
            },
            // Gets called once before editing starts, to give editor a chance to
            // cancel the editing before it even starts.
            isCancelBeforeStart() {
                return false;
            },
            // Gets called once when editing is finished (eg if Enter is pressed).
            // If you return true, then the result of the edit will be ignored.
            isCancelAfterEnd() {
                return false;
            }
        }
    })

    return (
        <NumberInput 
            value={currentValue}
            onChange={value => setCurrentValue(value)}
            ref={refInput}
            allowNegative={true}
        />
    )
})
 export default NumberCellEditor
